module.exports = __webpack_public_path__ + "img/group.54fda473.svg";